module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"title":"新着解析結果","count":"合計","month":"月分"},"en":{"title":"Recent","count":"Total","month":" "}}')
  delete Component.options._Ctor
}
